export default "/assets/images/monthly-home-health-report-thumbnail.jpg?17b0608211909b58e41d53631e58b0e1";